export default function isStringDefined(str: any): str is string {
  return (
    typeof str === 'string' &&
    str.replace(/\s+/g, '') !== '' &&
    str.trim() !== ''
  );
}
